<template>
    <div @click="$emit('close')" v-if="open">
        <div class="block modal modal-mask select-none">
            <div class="modal-dialog" :class="{ 'modal-lg': large }">
                <transition
                    enter-active-class="transition ease-out duration-500 transform"
                    enter-class="opacity-0 -translate-y-full"
                    enter-to-class="opacity-100"
                    @after-leave="$emit('close')">
                    <div v-if="showContent" class="modal-content select-auto" @click.stop>
                        <slot></slot>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        open: {
            type: Boolean,
            default: false,
        },
        large: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            showContent: false,
        };
    },

    mounted() {
        this.showContent = this.open;
    },

    watch: {
        open(value) {
            if (value === true) {
                document.body.classList.add('modal-open');
            } else {
                document.body.classList.remove('modal-open');
            }
            this.$nextTick(() => this.showContent = value);
        },
    },
};
</script>
